// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"f45d7fc6","34":"2fbf11f6","728":"7f652c9e"}[chunkId] + ".chunk.js";
};